import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewRef,LOCALE_ID,EventEmitter,Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormControl } from '@angular/forms'
import { MatDrawer, MatSnackBar } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, NoteService, StateService,DocumentService } from '../../../../../services'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

const KEY = 'note-dialog'

@Component({
	selector: 'atyl-note-dialog',
	templateUrl: './note-dialog.component.html',
	styleUrls: ['./note-dialog.component.scss'],
  	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/general/note',
	key: KEY,
})
export class NoteDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY) strings: any

	@ViewChild('drawer', { static: false }) drawer: MatDrawer
	config: any = {
		placeholder: 'Label',
		height: '15vh',
		toolbar: [
			['style', ['bold', 'italic', 'underline']],
			['para', ['ul', 'ol', 'paragraph', 'height']],
			['insert', ['table']]
		],
		disableDragAndDrop: true
	};
	instruction:any;
	
	dossier:any;
     
    types:any=[];
     
    notes:any[]=[];
    @Output() lengthNote: EventEmitter<number> = new EventEmitter<number>();
    
    
    loadingTable:boolean=false;
    
     columns:any[]=[];
    
	IdInput:number=0;
	typeInput:number=0;
    LibelleInput:any;
    DateDebutInput:any;
    DateFinInput:any;
    NoteInput:any;
    FileInput:any;
    UrlInput:any;
    
    tiersInput:any;
     
	constructor(
		public dialogRef: MatDialogRef<NoteDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public stateService: StateService,			
		changeDetectorRef: ChangeDetectorRef,
		private noteService: NoteService,
		dialogService: DialogService,
		private documentService: DocumentService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		this.config.placeholder=this.strings.dialog.note;
		
		this.columns=[
	{
		id:"type_libelle",
		label:this.strings.dialog.type,
		visible: true
	},
	
	{
		id:"libelle",
		label:this.strings.dialog.label,
		visible: true
	},
	
	{
		id:"date_debut_aff",
		label:this.strings.dialog.begin,
		visible: true
	},
	{
		id:"date_fin_aff",
		label:this.strings.dialog.end,
		visible: true
	},
	{
		id:"note",
		label:this.strings.dialog.note,
		visible: true
	},
	];
		
		this.loadNoteType();
		
		if (this.data.dossier!=undefined && this.data.dossier ) {
			this.dossier = this.data.dossier
		}
		if (this.data.instruction!=undefined && this.data.instruction ) {
			this.instruction = this.data.instruction
		}
		
		this.loadNote();
	}

	detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
    loadNoteType() {
      this.noteService.types().subscribe(
		   (res: JSONRpcResponse) => {
			   if (res.result 
					&& res.result!=undefined
				) {
					
					this.types=res.result;
					}
			});
			
	}		   
	loadNote() {
		
		
		
	   console.log(" NoteDialogComponent load ",this.dossier,this.instruction);	
	   
	   let _opts:any={
		   
	   }
	   if (this.dossier!=undefined && this.dossier.ID!=undefined)
	     _opts["dossier"]=this.dossier.ID;
	    if (this.instruction!=undefined && this.instruction.ID!=undefined)
	     _opts["instruction"]=this.instruction.ID;
	  this.notes=[];
	  this.loadingTable=true;
	   this.noteService.get(_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("NoteComponent loaded",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.notes=res.result;
					this.lengthNote.emit( res.result.length)
					this.detectChanges();
				}
				this.loadingTable=false;	
			}
	   );
	   	
   }
   
   rowTableClicked(event:any) {
		console.log("NoteDialogComponent rowTableClicked",event)
		this.IdInput=event.ID;
		this.typeInput=event.type;
		this.LibelleInput=event.libelle;
		this.NoteInput=event.note;
		this.DateDebutInput=event.date_debut;
		this.DateFinInput=event.date_fin;
		this.tiersInput=undefined;
		
		if (event.objets.length>0) {
			for(let i:number=0;i<event.objets.length;i++) {
				let o:any=event.objets[i];
				//console.log("NoteDialogComponent rowTableClicked o",i,o)
				if (o.tiers!=undefined)
				  this.tiersInput=o.tiers;
			}
		}
		
		this.UrlInput=undefined;
		if (event.url) {
			this.UrlInput=event.url;
		}
		this.detectChanges();
    }
    
	selectChanged(event:any) {
		console.log("NoteDialogComponent selectChanged",event)
		this.detectChanges();

	}
	cancelNote(event: MouseEvent) {
		this.cleanVariable()
		this.detectChanges();
	}
	
	cleanVariable() {
		this.IdInput=0;
		this.typeInput=0;
		this.tiersInput=undefined;
		this.FileInput=undefined;
		this.UrlInput=undefined;
		this.LibelleInput = undefined
		this.DateDebutInput = undefined
		this.DateFinInput = undefined
		this.NoteInput = ""
		
	}
	saveNote(event: MouseEvent) {
		
		 let _opts:any={
		   type:this.typeInput ,
		   libelle: this.LibelleInput,
		   debut: this.DateDebutInput,
		   fin: this.DateFinInput,
		   note: this.NoteInput,
		   file: this.FileInput
	   }
	   
	    if (this.dossier!=undefined && this.dossier.ID!=undefined)
	     _opts["dossier"]=this.dossier.ID;
	    if (this.instruction!=undefined && this.instruction.ID!=undefined)
	     _opts["instruction"]=this.instruction.ID;
	     
	     this.noteService.set(this.IdInput,_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("NoteComponent set",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.loadNote();
					this.cleanVariable();
					this.detectChanges();
				}
				
			}
	   ); 
	     
	   
	}
	
	deleteNote(event: MouseEvent) {
		
		 let _opts:any={
		   etat: 0
	   }
	   
	   
	     
	     this.noteService.set(this.IdInput,_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("NoteComponent set",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.loadNote();
					this.cleanVariable();
					this.detectChanges();
				}
				
			}
	   ); 
	     
	   
	}
	
	goDossier(event: MouseEvent) {
		console.log("NoteDialogComponent goDossier o",this.tiersInput)
		if (this.tiersInput!=undefined) {
			
			 this.router.navigate(['/home/dossier/' + this.tiersInput.type+'/' + this.tiersInput.dossierID], {
                        relativeTo: this.activatedRoute,
             })
		}
	}
	
	checkFileSize(fsize: any, sizelimit: any) {
		const file = (fsize / ONE_MB_IN_BYTES).toFixed(2)
		if (file >= sizelimit)
			return false
		else
			return true
	}
	
	uploadFile(event, documentselected) {
		const element = event[0]
		this.FileInput=undefined;
		if (this.checkFileSize(element.size, 25)) {
			
			this.documentService.uploadDocument(element).subscribe((res: any) => {
				/*this.result.selectedDocument.uploaded = true
				this.notUploaded = false
				this.result.selectedDocument.value = res
				this.result.selectedDocument.value.description = this.result.selectedDocument.description
				this.result.selectedDocument.libelle = this.result.selectedDocument.value.file
				this.result.selectedDocument.value.libelle = this.result.selectedDocument.value.file*/
				console.log("NoteDialogComponent uploadFiled",res)
				if (res.success!=undefined && res.success) {
					this.LibelleInput=res.file
					this.FileInput=res
				}
				
				
			})
			
		}
		else {
			
		}
	}
	
	downloadFile(event: MouseEvent) {
		console.log("NoteDialogComponent downloadFile ",this.UrlInput)
		if (this.UrlInput!=undefined) {
			 window.open(this.UrlInput, ' _blank')
		}
	}
	
	
}
